import React from "react";
import classNames from "classnames";

import styles from "./Spinner.module.scss";

const Spinner = ({ className }) => {
  return (
    <div className={classNames(styles.Spinner, className)}>
      <div className={styles.Container}>
        <div className={classNames(styles.Layer, styles.Layer1)}>
          <div className={styles.Circle}>
            <div className={classNames(styles.Spin, styles.LeftSpin)}></div>
          </div>

          <div className={styles.Circle}>
            <div className={classNames(styles.Spin, styles.RightSpin)}></div>
          </div>
        </div>

        <div className={classNames(styles.Layer, styles.Layer2)}>
          <div className={styles.Circle}>
            <div className={classNames(styles.Spin, styles.LeftSpin)}></div>
          </div>
          <div className={styles.Circle}>
            <div className={classNames(styles.Spin, styles.RightSpin)}></div>
          </div>
        </div>

        <div className={classNames(styles.Layer, styles.Layer3)}>
          <div className={styles.Circle}>
            <div className={classNames(styles.Spin, styles.LeftSpin)}></div>
          </div>
          <div className={styles.Circle}>
            <div className={classNames(styles.Spin, styles.RightSpin)}></div>
          </div>
        </div>

        <div className={classNames(styles.Layer, styles.Layer4)}>
          <div className={styles.Circle}>
            <div className={classNames(styles.Spin, styles.LeftSpin)}></div>
          </div>
          <div className={styles.Circle}>
            <div className={classNames(styles.Spin, styles.RightSpin)}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Spinner;
